module.exports = __webpack_public_path__ + "static/media/Asset37.662f5135.png";